const PREVIEW_HOST_REGEX = /^(?:staging-)?preview\.monito\.com/

export function isPreview(host?: string) {
  return process.env.NODE_ENV === 'development' || PREVIEW_HOST_REGEX.test(host ?? '')
}
